module.exports = __webpack_public_path__ + "img/payment_failure.26bca9f8.png";